document.addEventListener('DOMContentLoaded', function() {
  const brandForms = document.querySelectorAll('.collection-quiz-form__brand-form');
  
  brandForms.forEach(form => {
    const heading = form.querySelector('.collection-quiz-form__heading');
    const inputs = form.querySelector('.collection-quiz-form__inputs');
    
    if (heading && inputs) {
      heading.addEventListener('click', function() {
        const isOpen = form.getAttribute('data-accordion-open') === 'true';
        form.setAttribute('data-accordion-open', !isOpen);
      });
    }
  });
}); 